import { initializeApp, getApps, type FirebaseOptions } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  signInWithPopup,
  type Auth,
  type ConfirmationResult,
} from "firebase/auth";

export type FirebaseConfig = FirebaseOptions;

export function getFirebaseAuth(config: FirebaseConfig): Auth {
  if (!config.apiKey || !config.projectId) {
    throw new Error("Firebase configuration is missing.");
  }

  const app = getApps()[0] || initializeApp(config);
  const auth = getAuth(app);
  auth.languageCode = "ja";

  return auth;
}

export async function signInWithGoogle(config: FirebaseConfig): Promise<string> {
  const auth = getFirebaseAuth(config);
  const provider = new GoogleAuthProvider();
  const credential = await signInWithPopup(auth, provider);

  return credential.user.getIdToken();
}

export async function signInWithApple(config: FirebaseConfig): Promise<string> {
  const auth = getFirebaseAuth(config);
  const provider = new OAuthProvider("apple.com");
  provider.addScope("email");
  provider.setCustomParameters({ locale: "ja_JP" });
  const credential = await signInWithPopup(auth, provider);

  return credential.user.getIdToken();
}

export function createRecaptchaVerifier(auth: Auth, containerId: string): RecaptchaVerifier {
  return new RecaptchaVerifier(auth, containerId, {
    size: "invisible",
  });
}

export async function sendSmsCode(
  auth: Auth,
  phoneNumber: string,
  verifier: RecaptchaVerifier,
): Promise<ConfirmationResult> {
  return signInWithPhoneNumber(auth, phoneNumber, verifier);
}
